// import { getId } from './util'

// 快捷键处理
class GraphOnEvent {
  constructor (graph, history) {
    this.graph = graph
    this.history = history
  }

  // 快捷键
  init (keyboard, selection, clipboard) {
    keyboard.bindKey('backspace', () => {
      const cells = selection.getSelectedCells()
      cells.forEach(current => {
        const childrenList = this.graph.getCells().filter(item => {
          return (
            item?.data?.id?.includes(current.id) &&
            item?.data?.id !== current.id
          )
        })
        if (childrenList.length) {
          childrenList.forEach(item => {
            this.graph.removeCell(item)
          })
        }
      })
      this.graph.removeCells(cells)
      return false
    })
    keyboard.bindKey('ctrl+c', () => {
      const cells = selection.getSelectedCells()
      if (cells.length) {
        // 如果是子节点，则不可以进行复制
        if (cells[0].getProp().isChild) {
          return
        }
        
        const cellsToCopy = []
        
        cells.forEach(cell => {
          cellsToCopy.push(cell)
          
          // 如果是组合节点，需要收集其所有子节点
          if (cell.isNode() && cell.getData()?.isGroup && cell.getData()?.groupedNodes) {
            const groupedNodeIds = cell.getData().groupedNodes || []
            groupedNodeIds.forEach(nodeId => {
              const childNode = this.graph.getCellById(nodeId)
              if (childNode && !cellsToCopy.includes(childNode)) {
                cellsToCopy.push(childNode)
              }
            })
          }
          
          // 原有的子节点处理逻辑
          const children = cell?.children ? cell.children : []
          children.forEach(child => {
            if (!cellsToCopy.includes(child)) {
              cellsToCopy.push(child)
            }
          })
        })
        
        clipboard.copy(cellsToCopy)
      }
      return false
    })
    keyboard.bindKey('ctrl+v', () => {
      const list = clipboard.getCellsInClipboard()
      const edgesList = [] // 记录所有的连线数据
      const groupMapping = {} // 记录组合节点的新旧ID映射
      const childNodeMapping = {} // 记录子节点的新旧ID映射
      
      list.forEach(item => {
        const newId = item.id // 新元素的id
        const copyId = item.data?.id
        const nodeList = this.graph.getNodes()
        const edgeList = this.graph.getEdges()
        const childNodeList = nodeList.filter(item => {
          if (item?.data?.id?.includes(copyId) && item?.data?.id !== copyId) {
            return item
          }
        })
        childNodeList.forEach(childItem => {
          const current = JSON.parse(JSON.stringify(childItem))
          const childId = newId + parseInt(Math.random() * 100000)
          current.id = childId
          current.data.id = childId
          const { x, y } = current.position
          current.position = {
            x: x + 48,
            y: y + 48
          }
          this.graph.addNode(current)
          edgeList.forEach(child => {
            if (
              child?.target?.cell?.includes(childItem.data.id) &&
              child.source.cell.includes(copyId)
            ) {
              edgesList.push({
                source: {
                  cell: newId,
                  port: child.source.port,
                  vertices: child.vertices
                },
                target: {
                  cell: childId,
                  port: child.target.port,
                  vertices: child.vertices
                }
              })
            }
          })
        })
        if (item.data) {
          item.data.id = item?.id
        }
      })
      
      if (list.length) {
        clipboard.paste({
          offset: 48,
          nodeProps: {
            zIndex: 0
          }
        })
        
        // 处理组合节点的关系重建
        setTimeout(() => {
          const allNodesAfterPaste = this.graph.getNodes()
          const nodeIdMapping = {} // 新旧节点ID映射
          
          // 建立节点ID映射关系（基于粘贴偏移量）
          list.forEach(originalItem => {
            const newNode = allNodesAfterPaste.find(node => {
              const originalPos = originalItem.position || { x: 0, y: 0 }
              const newPos = node.getPosition()
              // 检查位置偏移是否为48像素（粘贴偏移量）
              return Math.abs(newPos.x - originalPos.x) === 48 && 
                     Math.abs(newPos.y - originalPos.y) === 48 &&
                     node.getData()?.text === originalItem.data?.text
            })
            
            if (newNode) {
              nodeIdMapping[originalItem.id] = newNode.id
            }
          })
          
          // 重建组合关系
          list.forEach(originalItem => {
            if (originalItem.data?.isGroup && originalItem.data?.groupedNodes) {
              const newGroupNodeId = nodeIdMapping[originalItem.id]
              const newGroupNode = newGroupNodeId ? this.graph.getCellById(newGroupNodeId) : null
              
              if (newGroupNode) {
                const originalGroupedNodes = originalItem.data.groupedNodes || []
                const newGroupedNodes = []
                
                // 为每个原始子节点找到对应的新节点ID
                originalGroupedNodes.forEach(originalChildId => {
                  const newChildNodeId = nodeIdMapping[originalChildId]
                  if (newChildNodeId) {
                    const newChildNode = this.graph.getCellById(newChildNodeId)
                    if (newChildNode) {
                      newGroupedNodes.push(newChildNodeId)
                      // 设置子节点的父组信息
                      newChildNode.setData({
                        ...newChildNode.getData(),
                        parentGroup: newGroupNodeId
                      })
                    }
                  }
                })
                
                // 更新组合节点的子节点列表
                newGroupNode.setData({
                  ...newGroupNode.getData(),
                  groupedNodes: newGroupedNodes
                })
                
                console.log(`成功重建组合关系: ${originalItem.data.groupName}, 包含 ${newGroupedNodes.length} 个子节点`)
              }
            }
          })
        }, 100)
      }
      
      for (let i = 0; i < edgesList.length; i++) {
        const itemEdge = edgesList[i]
        const { vertices } = itemEdge.source
        this.graph.addEdge({
          source: { cell: itemEdge.source.cell, port: itemEdge.source.port },
          target: { cell: itemEdge.target.cell, port: itemEdge.target.port },
          attrs: {
            line: {
              stroke: '#8f8f8f',
              strokeWidth: 2,
              targetMarker: '',
              sourceMarker: ''
            }
          },
          vertices: { x: vertices.x + 48, y: vertices.y + 48 },
          zIndex: 0,
          connector: 'smooth'
        })
      }
    })
    keyboard.bindKey('ctrl+x', () => {
      const cells = selection.getSelectedCells()
      if (cells.length) {
        this.graph.removeCells(cells)
      }
      return false
    })
    keyboard.bindKey('ctrl+z', () => {
      this.history.undo()
      return false
    })
    keyboard.bindKey('ctrl+y', () => {
      this.history.redo()
      return false
    })
    
    // 组合快捷键 Ctrl+G
    keyboard.bindKey('ctrl+g', () => {
      const selectedCells = selection.getSelectedCells()
      const selectedNodes = selectedCells.filter(cell => cell.isNode())
      
      if (selectedNodes.length >= 2) {
        // 触发组合功能
        window.draftComponent?.groupSelectedNodes()
      }
      return false
    })
    
    // 取消组合快捷键 Ctrl+Shift+G
    keyboard.bindKey('ctrl+shift+g', () => {
      const selectedCells = selection.getSelectedCells()
      const groupNodes = selectedCells.filter(cell => 
        cell.isNode() && cell.getData()?.isGroup && cell.getData()?.groupedNodes
      )
      
      if (groupNodes.length >= 1) {
        // 触发取消组合功能
        window.draftComponent?.ungroupSelectedNodes()
      }
      return false
    })
  }
}

export default GraphOnEvent
